const STORAGE_KEY = 'CMS_CONTENT';

export function getCMSCache() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function setCMSCache(lastUpdated, data) {
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({lastUpdated, data})
    );
}
